/**
 * 트리 Vuex commit을 첫 paint 이후 idle 구간으로 미룸 (C1)
 */
export function schedulePanelTreeCommitAfterPaint(callback) {
  const run = () => {
    if (typeof callback === 'function') {
      callback();
    }
  };

  if (typeof window === 'undefined') {
    run();
    return;
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(run, { timeout: 120 });
      } else {
        setTimeout(run, 0);
      }
    });
  });
}
